import { useState } from 'react';
import CallTrackingTab from './CallTrackingTab';
import WebformLeadsSubTab from './WebformLeadsSubTab';

type Props = { af: string | null };

type SubTabId = 'calls-tracking' | 'calls-webform';

const SUBS: ReadonlyArray<{ id: SubTabId; label: string }> = [
  { id: 'calls-tracking', label: 'Call Tracking' },
  { id: 'calls-webform', label: 'Webform Leads' },
];

export default function CallsAndLeadsTab({ af }: Props) {
  const [sub, setSub] = useState<SubTabId>('calls-tracking');

  return (
    <>
      <div className="perf-sub-tabs">
        {SUBS.map((s) => (
          <button
            key={s.id}
            className={`perf-sub-btn ${sub === s.id ? 'active' : ''}`}
            onClick={() => setSub(s.id)}
          >
            {s.label}
          </button>
        ))}
      </div>

      {sub === 'calls-tracking' && <CallTrackingTab af={af} />}
      {sub === 'calls-webform' && <WebformLeadsSubTab af={af} />}
    </>
  );
}
